import styled from "styled-components";

// Utils
import { productPromotionPrice } from "../../utils/productPromotion";
import { buildUrl } from "../../utils/imgix";
import classnames from "classnames";
import StrikeText from "../global/StrikeText";

// Components
import Currency from "../Currency";
import Text from "../Text";
import {
  CartItemContainer,
  CartItemSection,
  ProductTitle,
  SectionWrapper,
  SubscriptionInfo,
} from "./CartItem";

// Redux
import { useSelector } from "react-redux";
import promotionSelectors from "../../store/promotion/selectors";

// Styled Elements

const ImageAndSectionContainer = styled.div`
  display: flex;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 97px;
  height: 105px;
  margin-right: var(--spacing-1);
  flex: 0 0 97px;
  overflow: hidden;
`;

const PromotionCartItemContainer = styled(CartItemContainer)`
  &::before {
    border-top: none;
  }
  &::after {
    border-top: none;
  }
`;

const PriceAndValueContainer = styled(SectionWrapper)`
  justify-content: space-between;
`;

const FreeGiftTitle = styled.h3`
  position: relative;
  z-index: 10;
  margin: -1px 0 0 0;
  color: var(--indigo-blue-60);
  background-color: var(--white);
  display: flex;
  align-items: center;

  span.title-text {
    flex: 0 0 auto;
    padding-right: var(--spacing-0_5);
  }

  span.title-line {
    width: 100%;
    flex: 1 1 auto;
    border-top: 1px solid var(--cool-40);
  }
`;

const Quantity = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  margin-left: auto;
  padding: 0;
  align-items: flex-end;

  p {
    margin: 0;
    padding: 0;
  }

  span {
    margin-top: auto;
    margin-left: var(--spacing-0_5);
  }
`;

const FreeText = styled.span`
  color: var(--indigo-blue) !important;
`;

function ProductPromotionCartItem({
  isFlyoutContext,
  simplified,
}: {
  isFlyoutContext: boolean;
  simplified: boolean;
}) {
  const product = useSelector(
    promotionSelectors.appliedProductPromotionProduct,
  );

  if (!product) {
    return null;
  }

  const classNames = classnames(
    simplified && "simplified",
    isFlyoutContext && "flyout",
  );

  const price = productPromotionPrice(product.sku);

  return (
    <>
      <FreeGiftTitle className="typography-caption">
        <span className="title-text">Free Gift</span>
        <span className="title-line" />
      </FreeGiftTitle>
      <PromotionCartItemContainer className={classNames}>
        <ImageAndSectionContainer>
          <ImageWrapper className={classNames}>
            <img
              loading="eager"
              alt={product.name}
              src={buildUrl(product.imagePath)}
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                zIndex: "0",
                userSelect: "none",
                pointerEvents: "none",
              }}
            />
          </ImageWrapper>
          <PriceAndValueContainer className={classNames}>
            <div>
              <CartItemSection>
                <ProductTitle>
                  <span className="typography-label3">{product.name}</span>
                  <span className="typography-label4 font-dutch">
                    <Text
                      id={"product.promotions.free-gift"}
                      defaultMessage={"Free Gift"}
                    />
                  </span>
                </ProductTitle>
              </CartItemSection>
            </div>
            <div>
              <CartItemSection>
                <SubscriptionInfo>
                  <div className="typography-caption">
                    <StrikeText>
                      {Currency({ round: true, value: price })}
                    </StrikeText>
                    <FreeText>Free</FreeText>
                  </div>
                </SubscriptionInfo>
              </CartItemSection>

              <CartItemSection>
                <SubscriptionInfo>
                  <span className="typography-caption savings">
                    {`${Currency({ round: true, value: price })} value`}
                  </span>
                </SubscriptionInfo>
              </CartItemSection>
            </div>
          </PriceAndValueContainer>
          <Quantity>
            <span className="typography-caption">Qty 1</span>
          </Quantity>
        </ImageAndSectionContainer>
      </PromotionCartItemContainer>
    </>
  );
}

export default ProductPromotionCartItem;
